module.exports = __webpack_public_path__ + "static/media/Comercializacion.20c6c0bd.png";